import { Issue } from "generated-graphql/graphql";

export type IssueSegment = NonNullable<Issue["schemaStack"]>[number];

export function hasModelInStack(issue: Issue | undefined | null, model: string): boolean {
  return issue?.schemaStack?.some((segment) => segment.model === model) ?? false;
}

export function anySegment(
  issue: Issue | undefined | null,
  predicate: (segment: IssueSegment) => boolean
): boolean {
  return issue?.schemaStack?.some(predicate) ?? false;
}

export function getIssueSchemaPathEquivalent(issue: Issue | undefined | null): string {
  if (!issue) return "";
  return (
    issue.schemaStack
      ?.map((s) => `${s.model}<${s.id != null && s.id !== "" ? s.id : "undefined"}>`)
      .join(".") ?? ""
  );
}

/**
 * Gets the issue description with chemical attribution.
 * If the issue has a Chemical in its schema stack, appends the chemical name in parentheses.
 */
export function attachChemicalToIssueDescription(issue: Issue): string {
  let description = issue.message;
  let chemicalSegment = null;

  // If the issue is directly on a Chemical, match by modelId
  if (issue.modelName === "Chemical") {
    chemicalSegment = issue.schemaStack?.find(
      (s) => s.model === "Chemical" && s.id === issue.modelId
    );
  } else {
    // For other issues, just find any Chemical segment
    chemicalSegment = issue.schemaStack?.find((s) => s.model === "Chemical");
  }

  // If we found a Chemical in the stack, add its name for context
  if (chemicalSegment?.name) {
    description = `${description} (${chemicalSegment.name})`;
  }

  return description;
}
